import React from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

const ControllerLayout: React.FC = () => (
  <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'auto' }}>
    <Outlet />
  </Box>
);

export default ControllerLayout;
